import { get } from '../httpHelpers/reporter';
import { BusinessUnit, Series } from '@cambridgeassessment/lib-ee-commons';
import { SearchQuery } from '../../types/Plagiarism';
import { mapQueryToParams } from '../../util/urlSearchParams';

export const downloadPlagiarismReport = async (
  businessUnitId: BusinessUnit['id'],
  seriesId: Series['id'],
  reportType: string,
  query?: SearchQuery,
): Promise<Blob> => {
  const params = mapQueryToParams(query);
  return await get(`v1/${businessUnitId}/series/${seriesId}/plagiarism/report/${reportType}?${params.toString()}`);
};
